import {defaultTo, find, flow, get, map} from '@yandex-delivery/utils'
import type {PollQuestion, PollQuestionAnswer, QuestionChoice, Subpoll} from 'src/api'

import type {PollType} from './Form.types'

export const getNewValues = (
  currentAnswerValues: string[] = [],
  answerId: string,
  choicesType: 'multi' | 'single',
): string[] => {
  const isAnswerExisted = currentAnswerValues.some(value => value === answerId)
  if (choicesType === 'single') {
    return [answerId]
  }
  if (!isAnswerExisted) {
    return currentAnswerValues.concat(answerId)
  }
  if (currentAnswerValues.length === 1) {
    return currentAnswerValues
  }
  return currentAnswerValues.filter(value => value !== answerId)
}

const getAnswerTextById = (answerId: string) =>
  flow(
    find<PollQuestionAnswer>(answer => answer.id === answerId),
    get('text'),
    defaultTo(''),
  )

const getQuestionChoice =
  (formValues: PollType) =>
  (question: PollQuestion): QuestionChoice => ({
    id: question.id,
    text: question.text,
    answers: (formValues[question.id] || []).map(currentAnswer => ({
      id: currentAnswer,
      text: getAnswerTextById(currentAnswer)(question.answers),
    })),
  })

const getQuestionsChoices = (formValues: PollType) => map(getQuestionChoice(formValues))

export const formToQuestionChoice = (subpolls: Subpoll[], formValues: PollType): QuestionChoice[] =>
  subpolls.reduce<QuestionChoice[]>(
    (acc, subpoll) => acc.concat(getQuestionsChoices(formValues)(subpoll.questions)),
    [],
  )
